import Utils from '@/common/utils/utils';
import APIAmplify from '@aws-amplify/api';
import { onChatThreadUpdate } from '@/graphql/subscriptions';
import Constant from '@/common/constant/Constant';


const SUBSCRIPTION_CHAT_THREAD_UPDATE = "CHAT_THREAD_UPDATE";
let chatThreadSubscriptionUpdate = null;


export const initSubscriptionChatThread = (
    chatThreadId,
    panelId,
    setVoiceStatus,
    voiceStatus
) => {
    if (Utils.isEmptyString(chatThreadId) || !Utils.isEmptyObject(chatThreadSubscriptionUpdate)) {
        return;
    }
    let subscription = APIAmplify.graphql({
        query: onChatThreadUpdate,
        variables: { id: chatThreadId },
        authMode: Constant.AUTH_MODE_API_KEY,
        timeout: 10000
    }).subscribe({
        next: async (resData) => {
            let chatThreadUpdated = resData.value.data.onChatThreadUpdate;

            if (chatThreadUpdated.conferenceStatus !== voiceStatus) {
                return setVoiceStatus(chatThreadUpdated.conferenceStatus);
            }
           
        },
        error: err => {
            console.log('--- onChatThreadUpdate error', err);
            unsubscribeChatThread()
        }
    });

    chatThreadSubscriptionUpdate = subscription

}
export const unsubscribeChatThread = () => {
    if (chatThreadSubscriptionUpdate?._state !== 'closed') {
        chatThreadSubscriptionUpdate?.unsubscribe();
    } 
};